var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.model.webHooksConfiguration.webHooks.length
        ? _c("ec-list", {
            attrs: {
              items: _vm.model.webHooksConfiguration.webHooks,
              dashed: "",
              dense: ""
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "left",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-col",
                        {
                          staticClass: "px-2 text-start text-oneline",
                          attrs: { cols: "12", md: "12" }
                        },
                        [
                          _c("span", { staticClass: "body-1" }, [
                            _vm._v(_vm._s(item.eventName))
                          ])
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "right",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-col",
                        {
                          staticClass: "text-start text-oneline",
                          attrs: { cols: "12", md: "12 ", title: item.url }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "primary--text text-caption",
                              on: {
                                click: function($event) {
                                  return _vm.$copyToClipboard(item.url)
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "px-1",
                                  attrs: { color: "primary", small: "" }
                                },
                                [_vm._v("mdi-content-copy")]
                              ),
                              _vm._v(" " + _vm._s(item.url) + " ")
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              1518360663
            )
          })
        : _c("p", [_vm._v(_vm._s(_vm.$t("NothingToShow")))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }